import React from "react";
import {createElement, PureComponent } from "react";
import { columnPropType } from "./propTypes";
import { getCellClassName } from "./utils";
export default class DataTableHeaderCell extends PureComponent {
  static propTypes = {
    column: columnPropType.isRequired,
  };

  render() {
    const { className, column, ...otherProps } = this.props;
    const compositeClassName = getCellClassName(column, className);
    const { label } = column;
    return (
      <th className={compositeClassName} {...otherProps}>
        {typeof label === "function" ? createElement(label) : label}
      </th>
    );
  }
}
